import { Injectable } from '@angular/core';
import { Headers } from '@angular/http';
@Injectable()
export class AppService {

  constructor() {
  }

  getCurrentUser() {
    return JSON.parse(sessionStorage.getItem('currentUser'));
  }

  getJwt() {
    return JSON.parse(sessionStorage.getItem('jwt'));
  }
}



// WEBPACK FOOTER //
// /build/client-cms/src/app/app.service.ts